<template>
  <div class="checkStatus">
    <div class="navbar">
      <div class="logo">
        <img src="../../assets/imgs/MES-LOGO.png" alt />
      </div>
    </div>
    <div class="centerbar">
      <div class="amazon">AMAZON ORDER ID</div>
      <div style="margin-bottom: 25px;">
        <el-input
          placeholder="please type your order id to check the status"
          v-model="formLabelAlign.amazonOrderId"
          class="input-with-select"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchID()"></el-button>
        </el-input>
      </div>
      <div v-show="showStatus" class="statusRed">be following up</div>
       <div v-show="showStatuss" class="statusRed">resolved</div>
      <!-- <div v-if="showBox == 1">查询</div>
      <div v-if="showBox == 2">查</div> -->
      <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
        <el-form-item label="Name">
          <el-input v-model="formLabelAlign.clientName"></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="formLabelAlign.clientMail"></el-input>
        </el-form-item>
        <el-form-item label="ASIN">
          <el-input v-model="formLabelAlign.asin"></el-input>
        </el-form-item>
        <el-form-item label="phone
        ">
          <el-input v-model="formLabelAlign.phone"></el-input>
        </el-form-item>
        <el-form-item label="Detailed Problem">
          <el-input v-model="formLabelAlign.detailedProblem"></el-input>
        </el-form-item>
        <el-form-item label="Detailed Demand">
          <el-input v-model="formLabelAlign.detailedDemand"></el-input>
        </el-form-item>
      
        <el-form-item label="processingProgress">
          <el-input v-model="formLabelAlign.processingProgress"></el-input>
        </el-form-item>
          <el-form-item label="Demand">
          <el-select v-model="formLabelAlign.demand" placeholder="Choose Demand">
            <el-option label="Refund" value="1"></el-option>
            <el-option label="Relacement" value="2"></el-option>
            <el-option label="Other" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="onSubmit" class="submit">Submit</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { apiCheckId ,apiAddAutoLoginList} from "../../api/checkstatus";
export default {
  data() {
    return {
      labelPosition: "top",
      formLabelAlign: {},
      amazonOrderId: "",
      showStatus: false,
      showStatuss:false,
      showBox:''
    };
  },

  methods: {
    onSubmit() {
      apiAddAutoLoginList(this.formLabelAlign).then((res) => {
        console.log(res);
        // if(res.data.code===201){
        //   this.$message.error(res.data.message)
        //   return false;
        // }
         if(res.data.flag != true){
          this.$message.error('AMAZON ORDER ID already exist')
          //  this.formLabelAlign = {}
        }else{
           if(res.data.code == 200){
           this.$message.success('true');
           this.formLabelAlign = {}
        }else{
           this.$message.error('AMAZON ORDER ID already exist')
            this.formLabelAlign = {}
        }
        }
      });
    },

    searchID() {
        if(this.formLabelAlign.amazonOrderId == undefined){
        this.$message.error('AMAZON ORDER ID can not be empty ')
      }else{
        apiCheckId(this.formLabelAlign.amazonOrderId).then((res) => {
        if(res.data.code===200){
          this.$message.success('true');
          this.formLabelAlign = res.data.data;
          this.showBox = res.data.data.status;
          if(this.showBox == 1){
            this.showStatus = true;
          }else{
            this.showStatuss = true;
          }
        }else{
          this.$message.error('false')
          this.formLabelAlign = {}
        }
      });
      }
      // apiCheckId(this.formLabelAlign.amazonOrderId).then((res) => {
      //   console.log(res);
      //   this.formLabelAlign = res.data.data;
      //   console.log(this.formLabelAlign);
      //   // if(res.data.code===200){
      //   //   this.$router.push('/AutoLogin')
      //   // }
      // });
    },
  },
};
</script>

<style lang='less' scoped>
.checkStatus {
  .amazon{
    margin-bottom: 10px;
    color: #696969;
  }
  .statusRed{
    color: red;
    margin-bottom: 8px;
  }
  background-color: #e4e5e6;
  min-height: calc(100vh);
  .navbar {
    height: 55px;
    min-width: 1366px;
    background-color: #fff;
    border-bottom: 1px solid #c8ced3;
    margin: 0 auto;
    overflow: hidden;
    .logo {
      width: 162px;
      height: 40px;
      margin-top: 0px;
      float: left;
      img {
        width: 100%;
      }
    }
  }

  .centerbar {
    position: relative;
    padding: 30px 30px 5px;
    width: 500px;
    margin: 30px auto 0;
    background-color: antiquewhite;
    /deep/.el-form--label-top .el-form-item__label {
      padding: 0px !important;
    }
    /deep/.el-form-item {
      margin-bottom: 10px !important;
    }
    .submit {
      position: absolute;
      bottom: 10px;
      right: 0px;
    }
  }
}
</style>